import { render, staticRenderFns } from "./PsPatientSubscriptionHistory.vue?vue&type=template&id=3fa152a7&scoped=true&"
import script from "./PsPatientSubscriptionHistory.vue?vue&type=script&lang=js&"
export * from "./PsPatientSubscriptionHistory.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientSubscriptionHistory.vue?vue&type=style&index=0&id=3fa152a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa152a7",
  null
  
)

export default component.exports